module.exports = __webpack_public_path__ + "img/0Q3A2361_L_Black_MockedUp.ca4a2eb8.jpg";